<div class="page-body">
  <div *ngIf="!loading && !navigationInProgress && error" class="error-wrapper">
    <div class="contents-container">
      <p class="heading">Något gick fel.</p>
      <p class="info-text">
        Vänligen prova att ladda om sidan eller försök igen lite senare.
      </p>
    </div>
  </div>

  <div *ngIf="(navigationInProgress || loading) && !error">
    <app-spinner></app-spinner>
  </div>

  <div *ngIf="!loading && !error && !navigationInProgress">
    <div class="banner">
      <button type="button" class="back-button" (click)="reroute()">
        <app-zaver-icon [size]="14" name="chevronLeft"></app-zaver-icon>
        <span>Tillbaka</span>
      </button>
    </div>

    <div class="contents-wrapper">
      <div class="contents-container">
        <form [formGroup]="formGroup" novalidate>
          <zaver-stepper [shouldHideDefaultButtons]="true">
            <!-- STEP 1 -->
            <ng-template #step let-index>
              <div>
                <div class="step-heading">
                  Några snabba frågor innan vi fortsätter
                </div>

                <p class="step-sub-heading">
                  Innan vi kan erbjuda det här sättet att betala behöver vi,
                  enligt lag, ställa ett par frågor om din ekonomi.
                </p>
              </div>
            </ng-template>

            <!-- STEP 2 -->
            <ng-template
              *ngIf="selectedMethodLeqType === LeqType.STANDARD"
              #step
              let-index
            >
              <div>
                <div class="step-heading">Vad har du för sysselsättning?</div>
                <div class="pill-selector">
                  <zaver-pill-selector
                    [(selectedOption)]="selectedEmploymentOption"
                    [options]="employmentOptions"
                  ></zaver-pill-selector>
                </div>
              </div>
            </ng-template>

            <!-- STEP 3 -->
            <ng-template
              *ngIf="selectedMethodLeqType === LeqType.STANDARD"
              #step
              let-index
            >
              <div>
                <div class="step-heading">
                  Vad har du för månadsinkomst efter skatt?
                </div>
                <div class="form-input-container">
                  <zaver-animated-form-input
                    formControlName="income"
                    [error]="formGroup.controls.income.invalid && showError"
                    ariaLabel="Ange belopp"
                    placeholder="Ange belopp"
                    errorMessage="Vänligen ange en siffra mellan 0 och 1 000 000"
                    inputMode="text"
                    [errorIcon]="'assets/icon/icon_error.svg'"
                    [showContent]="true"
                    >kr</zaver-animated-form-input
                  >
                </div>
              </div>
            </ng-template>

            <!-- STEP 4 -->
            <ng-template
              *ngIf="selectedMethodLeqType === LeqType.STANDARD"
              #step
              let-index
            >
              <div>
                <div class="step-heading">Vad har du för typ av boende?</div>
                <div class="pill-selector">
                  <zaver-pill-selector
                    [(selectedOption)]="selectedHousingTypeOption"
                    [options]="housingTypeOptions"
                  ></zaver-pill-selector>
                </div>
                <div class="form-input-container">
                  <div class="input-text">
                    Vad är din totala boendekostnad per månad?
                  </div>
                  <zaver-animated-form-input
                    formControlName="housingCosts"
                    [error]="
                      formGroup.controls.housingCosts.invalid && showError
                    "
                    ariaLabel="Ange belopp"
                    placeholder="Ange belopp"
                    errorMessage="Vänligen ange en siffra mellan 0 och 1 000 000"
                    inputMode="text"
                    [errorIcon]="'assets/icon/icon_error.svg'"
                    [showContent]="true"
                    >kr</zaver-animated-form-input
                  >
                </div>
              </div>
            </ng-template>

            <!-- STEP 5 -->
            <ng-template #step let-index>
              <div>
                <div class="step-heading">
                  Har du några privatlån (blancolån)?
                </div>
                <div class="pill-selector">
                  <zaver-pill
                    text="Ja"
                    [isSelected]="hasCreditLoan"
                    (click)="hasCreditLoan = true"
                  >
                  </zaver-pill>
                  <zaver-pill
                    text="Nej"
                    [isSelected]="!hasCreditLoan"
                    (click)="hasCreditLoan = false"
                  >
                  </zaver-pill>
                </div>
                <div *ngIf="hasCreditLoan" class="form-input-container">
                  <div class="input-text">
                    Hur mycket har du kvar att betala totalt?
                  </div>
                  <zaver-animated-form-input
                    formControlName="creditCosts"
                    [error]="
                      formGroup.controls.creditCosts.invalid && showError
                    "
                    ariaLabel="Ange belopp"
                    placeholder="Ange belopp"
                    errorMessage="Vänligen ange en siffra mellan 0 och 1 000 000"
                    inputMode="text"
                    [errorIcon]="'assets/icon/icon_error.svg'"
                    [showContent]="true"
                    >kr</zaver-animated-form-input
                  >
                </div>
              </div>
            </ng-template>

            <!-- STEP 6 -->
            <ng-template #step let-index>
              <div>
                <div class="step-heading">
                  Betalar du på CSN-lån varje månad?
                </div>
                <div class="pill-selector">
                  <zaver-pill
                    text="Ja"
                    [isSelected]="hasStudentLoan"
                    (click)="hasStudentLoan = true"
                  >
                  </zaver-pill>
                  <zaver-pill
                    text="Nej"
                    [isSelected]="!hasStudentLoan"
                    (click)="hasStudentLoan = false"
                  >
                  </zaver-pill>
                </div>
                <div *ngIf="hasStudentLoan" class="form-input-container">
                  <div class="input-text">Hur mycket betalar du per månad?</div>
                  <zaver-animated-form-input
                    formControlName="studentLoan"
                    [error]="
                      formGroup.controls.studentLoan.invalid && showError
                    "
                    ariaLabel="Ange belopp"
                    placeholder="Ange belopp"
                    errorMessage="Vänligen ange en siffra mellan 0 och 1 000 000"
                    inputMode="text"
                    [errorIcon]="'assets/icon/icon_error.svg'"
                    [showContent]="true"
                    >kr</zaver-animated-form-input
                  >
                </div>
              </div>
            </ng-template>

            <!-- STEP 7 -->
            <ng-template
              *ngIf="selectedMethodLeqType === LeqType.STANDARD"
              #step
              let-index
            >
              <div>
                <div class="step-heading">
                  Ange övriga levnadskostnader per månad, utöver boende och lån.
                </div>
                <div class="form-input-container">
                  <zaver-animated-form-input
                    formControlName="miscExpenses"
                    [error]="
                      formGroup.controls.miscExpenses.invalid && showError
                    "
                    ariaLabel="Ange belopp"
                    placeholder="Ange belopp"
                    errorMessage="Vänligen ange en siffra mellan 0 och 1 000 000"
                    inputMode="text"
                    [errorIcon]="'assets/icon/icon_error.svg'"
                    [showContent]="true"
                    >kr</zaver-animated-form-input
                  >
                </div>
              </div>
            </ng-template>

            <!-- STEP 8 -->
            <ng-template #step let-index>
              <div>
                <div class="step-heading">Har du barn som du försörjer?</div>
                <div class="pill-selector">
                  <zaver-pill
                    text="Ja"
                    [isSelected]="hasChildren"
                    (click)="hasChildren = true"
                  >
                  </zaver-pill>
                  <zaver-pill
                    text="Nej"
                    [isSelected]="!hasChildren"
                    (click)="hasChildren = false"
                  >
                  </zaver-pill>
                </div>
                <div *ngIf="hasChildren" class="form-input-container">
                  <div class="input-text">Hur många barn?</div>
                  <zaver-animated-form-input
                    formControlName="numberOfChildren"
                    [error]="
                      formGroup.controls.numberOfChildren.invalid && showError
                    "
                    ariaLabel="Ange antal barn"
                    placeholder="Ange antal barn"
                    errorMessage="Vänligen ange en siffra mellan 0 och 50"
                    inputMode="text"
                    [errorIcon]="'assets/icon/icon_error.svg'"
                  ></zaver-animated-form-input>
                </div>
              </div>
            </ng-template>
          </zaver-stepper>
        </form>

        <div class="footer-container">
          <zaver-basic-button
            class="step-back-button"
            text="Tillbaka"
            [secondary]="true"
            [md]="true"
            [disabled]="navigationInProgress"
            (click)="handleBackClick()"
          >
          </zaver-basic-button>

          <zaver-basic-button
            text="Nästa"
            [primary]="true"
            [md]="true"
            [disabled]="navigationInProgress"
            (click)="handleContinueClick()"
          >
          </zaver-basic-button>
        </div>
      </div>
    </div>
  </div>
</div>
